<template>
  <a-modal
    :visible="visible"
    title="回放管理"
    @cancel="handleCancel"
    width="900px"
    :footer="null"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="回放类型">
              <a-select v-model="queryParam.replayType" placeholder="请选择" allowClear style="width: 100%">
                <a-select-option :value="1">视频</a-select-option>
                <a-select-option :value="2">音频</a-select-option>
                <a-select-option :value="3">富文本</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operations">
      <a-button type="primary" @click="handleAdd" v-hasPermi="['livecourse:liveCourseSectionReplay:add']">
        <a-icon type="plus" />新增
      </a-button>
    </div>
    <a-table
      :loading="loading"
      :columns="columns"
      :data-source="data"
      :pagination="pagination"
      @change="handleTableChange"
      rowKey="id"
      size="middle"
    >
      <span slot="replayType" slot-scope="text">
        <a-tag v-if="text === 1" color="blue">视频</a-tag>
        <a-tag v-else-if="text === 2" color="green">音频</a-tag>
        <a-tag v-else-if="text === 3" color="orange">富文本</a-tag>
      </span>
      <span slot="screenOrientation" slot-scope="text, record">
        <span v-if="record.replayType === 1">
          <a-tag v-if="text === 1" color="purple">竖屏</a-tag>
          <a-tag v-else-if="text === 2" color="cyan">横屏</a-tag>
          <span v-else>-</span>
        </span>
        <span v-else>-</span>
      </span>
      <span slot="isAllowDownload" slot-scope="text, record">
        <span v-if="record.replayType === 3">-</span>
        <a-tag v-else-if="text === 1" color="green">允许</a-tag>
        <a-tag v-else color="red">不允许</a-tag>
      </span>
      <span slot="replayUrl" slot-scope="text, record">
        <span v-if="record.replayType === 3">
          <a @click="handlePreviewRichContent(record)">预览内容</a>
        </span>
        <a v-else :href="text" target="_blank" v-if="text">{{ text.length > 30 ? text.substring(0, 30) + '...' : text }}</a>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleUpdate(record)" v-hasPermi="['livecourse:liveCourseSectionReplay:edit']">修改</a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record)" v-hasPermi="['livecourse:liveCourseSectionReplay:remove']">删除</a>
      </span>
    </a-table>
    <replay-create-form
      ref="replayCreateForm"
      :section-id="sectionId"
      :live-id="liveId"
      @ok="getList"
    />
    <a-modal
      title="富文本内容预览"
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
      width="800px"
    >
      <div class="rich-content-preview" v-html="previewContent"></div>
    </a-modal>
  </a-modal>
</template>

<script>
import { pageLiveCourseSectionReplay, delLiveCourseSectionReplay } from '@/api/livecourse/liveCourseSectionReplay'
import ReplayCreateForm from './ReplayCreateForm'

export default {
  name: 'ReplayModal',
  components: { ReplayCreateForm },
  data() {
    return {
      visible: false,
      loading: false,
      sectionId: null,
      sectionName: '',
      liveId: null,
      queryParam: {
        sectionId: null,
        replayType: null
      },
      columns: [
        { title: '序号', dataIndex: 'rowIndex', width: 60, customRender: (text, record, index) => index + 1 },
        { title: '回放地址/内容', dataIndex: 'replayUrl', scopedSlots: { customRender: 'replayUrl' } },
        { title: '回放类型', dataIndex: 'replayType', scopedSlots: { customRender: 'replayType' }, width: 100 },
        { title: '视频方向', dataIndex: 'screenOrientation', scopedSlots: { customRender: 'screenOrientation' }, width: 100 },
        { title: '是否允许下载', dataIndex: 'isAllowDownload', scopedSlots: { customRender: 'isAllowDownload' }, width: 120 },
        { title: '创建时间', dataIndex: 'createTime', width: 160 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 120 }
      ],
      data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`
      },
      previewVisible: false,
      previewContent: ''
    }
  },
  methods: {
    show(sectionId, sectionName, liveId) {
      this.sectionId = sectionId
      this.sectionName = sectionName
      this.liveId = liveId
      this.queryParam.sectionId = sectionId
      this.visible = true
      this.getList()
    },
    handleCancel() {
      this.visible = false
      this.queryParam = {
        sectionId: null,
        replayType: null
      }
      this.data = []
    },
    getList() {
      this.loading = true
      const param = {
        ...this.queryParam,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      pageLiveCourseSectionReplay(param).then(response => {
        this.data = response.data.records
        this.pagination.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam.replayType = null
      this.pagination.current = 1
      this.getList()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleAdd() {
      this.$refs.replayCreateForm.handleAdd()
    },
    handleUpdate(record) {
      this.$refs.replayCreateForm.handleUpdate(record)
    },
    handleDelete(record) {
      this.$confirm({
        title: '确认删除',
        content: '是否确认删除该回放记录?',
        onOk: () => {
          delLiveCourseSectionReplay([record]).then(() => {
            this.$message.success('删除成功')
            this.getList()
          })
        }
      })
    },
    handlePreviewRichContent(record) {
      this.previewContent = record.richContent
      this.previewVisible = true
    }
  }
}
</script>

<style scoped>
.rich-content-preview {
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
</style>
